import purchaseOrderTypeService from "../../../../services/procurementService/purchaseOrderTypeService";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CACHE_KEY_PURCHASEORDERTYPES } from "../../../../utils/constants";
import { PurchaseOrderTypeInterface } from "../../../../models/ProcurementModule/PurchateOrder/PurchaseOrderType";

interface DeletePurchaseOrderTypeContext {
  previousPurchaseOrderTypes: PurchaseOrderTypeInterface[];
  deletedPurchaseOrderType: PurchaseOrderTypeInterface | undefined;
}

const useDeletePurchaseOrderType = (page: number, pageSize: number) => {
  const queryClient = useQueryClient();

  return useMutation<
    void, // No return data after deletion
    Error,
    string, // ID of the customer to delete
    DeletePurchaseOrderTypeContext
  >({
    mutationFn: purchaseOrderTypeService.Remove, // Remove should take a string ID

    onMutate: (purchaseOrderTypeId: string) => {
      const previousPurchaseOrderTypes =
        queryClient.getQueryData<PurchaseOrderTypeInterface[]>([
          CACHE_KEY_PURCHASEORDERTYPES,
          page,
          pageSize,
        ]) || [];

      // Optimistically update the cache
      queryClient.setQueryData<PurchaseOrderTypeInterface[]>(
        [CACHE_KEY_PURCHASEORDERTYPES, page, pageSize],
        previousPurchaseOrderTypes.filter(
          (purchaseOderType) => purchaseOderType.id !== purchaseOrderTypeId
        ) // Use statusId to filter
      );

      return {
        previousPurchaseOrderTypes,
        deletedPurchaseOrderType: previousPurchaseOrderTypes.find(
          (purchaseOderType) => purchaseOderType.id === purchaseOrderTypeId
        ),
      };
    },

    onError: (error, purchaseOrderTypeId, context) => {
      if (!context) return;

      // Rollback to the previous state in case of error
      queryClient.setQueryData<PurchaseOrderTypeInterface[]>(
        [CACHE_KEY_PURCHASEORDERTYPES, page, pageSize],
        context.previousPurchaseOrderTypes
      );
    },

    onSuccess: () => {
      // Optionally, you could perform additional actions on success
      // For example, invalidating queries or updating other parts of the state
    },
  });
};

export default useDeletePurchaseOrderType;
